import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Papa from 'papaparse';
import AddCartButton from '../components/AddCartButton';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

// Pages to search (includes events and static pages)
const pages = [
  { title: 'Events', path: '/events' },
  { title: 'History', path: '/history' },
  { title: 'Library', path: '/library' },
  { title: 'Privacy Policy', path: '/privacypolicy' },
  { title: 'Terms and Conditions', path: '/termsandconditions' },
  { title: 'Contact Us', path: '/contactus' },
  { title: 'Transhuman Rights', path: '/transhumanrights' },
  { title: 'Volunteer', path: '/volunteer' },
];

const SearchResults = ({ cart, setCart }) => {
  const query = useQuery();
  const q = query.get('q') || '';
  const scope = query.get('scope') || 'all';
  const [products, setProducts] = useState([]);
  const [results, setResults] = useState([]);
  const [pageResults, setPageResults] = useState([]);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/ProductData.csv')
      .then(res => res.text())
      .then(text => {
        const parsed = Papa.parse(text, { header: true, dynamicTyping: true }).data;
        // Convert images string to array
        parsed.forEach(item => {
          if (item.images) {
            item.images = item.images.split('|').map(img => img.trim());
          } else {
            item.images = [];
          }
        });
        setProducts(parsed);
      });
  }, []);

  useEffect(() => {
    // Filter products for shop
    const shopFiltered = products.filter(item =>
      item.name.toLowerCase().includes(q.toLowerCase()) ||
      (item.description || '').toLowerCase().includes(q.toLowerCase())
    );
    setResults(shopFiltered);
    // Filter pages
    const pageFiltered = pages.filter(p =>
      p.title.toLowerCase().includes(q.toLowerCase())
    );
    setPageResults(pageFiltered);
  }, [products, q]);

  const addToCart = (item) => {
    const existingIndex = cart.findIndex(c => c.id === item.id && c.type === item.type);
    const updated = existingIndex >= 0
      ? cart.map((c,i) => i === existingIndex ? { ...c, quantity: (c.quantity||1)+1 } : c)
      : [...cart, { ...item, quantity: 1 }];
    setCart(updated);
  };

  return (
    <div className="main">
      <div className="column1"></div>
      <div className="column2">
        <h2>Search results for "{q}"</h2>
        {/* Shop results */}
        {(scope === 'shop' || scope === 'all') && (
          <>
            {results.length === 0 && <p>No shop results found.</p>}
            <div className="catalog-grid-row">
              {results.map(item => (
                <div key={item.id} className="product-card">
                  <h3 className="product-title">{item.name}</h3>
                  <p className="product-description">{item.description}</p>
                  <div className="product-image-wrapper">
                    {item.images.map((img,i) => (
                      <img key={i} src={process.env.PUBLIC_URL + img} alt={item.name} className="product-img" />
                    ))}
                  </div>
                  <AddCartButton item={item} onAddToCart={addToCart} />
                </div>
              ))}
            </div>
          </>
        )}
        {/* Page results */}
        {(scope === 'page' || scope === 'all') && (
          <div className="page-results">
            {pageResults.length === 0 && <p>No page results found.</p>}
            <ul>
              {pageResults.map(p => (
                <li key={p.path}>
                  <Link to={p.path}>{p.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="column3"></div>
    </div>
  );
};

export default SearchResults;